import { Button, DialogHeader, DialogBody, DialogFooter } from "@material-tailwind/react";
import { Modal } from "./Modal";
import { t } from "i18next";

export const VolumeRequestModal = ({ volume, ...props }) => (
  <Modal {...props}>{({ handleConfirm, handleCancel }) => <>
    <DialogHeader>
      <div>{t('dialogs.volume_request.confirm_change_line')}</div>
    </DialogHeader>
    <DialogBody>
    {t('dialogs.volume_request.question')}
      <div className="font-bold text-3xl font-bebasneue tracking-wider my-2">
        {volume} / 100
      </div>
    </DialogBody>
    <DialogFooter>
      <Button variant="filled" color="yellow" onClick={handleCancel} className="mr-2">
        <span>{t('dialogs.no')}</span>
      </Button>
      <Button variant="filled" color="yellow" onClick={handleConfirm}>
        <span>{t('dialogs.yes')}</span>
      </Button>
    </DialogFooter>
  </>}</Modal>
);
